<template>
  <v-row>
    <v-expansion-panels
      accordion
      v-model="servicePriceListPanel"
    >
      <v-expansion-panel
        v-for="(price, index) in prices"
        :key="index"
      >
        <v-expansion-panel-header>
          <input-checkbox
            v-bind:any="someServicesInPriceListSelected(price)"
            v-bind:title="price.name"
            v-bind:value="allServicesInPriceListSelected(price)"
            v-on:input="toggleServicesInPriceList(price)"
            v-on:click.native.capture.stop=""
          />
        </v-expansion-panel-header>
        <v-expansion-panel-content>
          <v-expansion-panels
            accordion
            v-model="serviceCategoryPanel"
          >
            <v-expansion-panel
              v-for="(parentCategory, index) in getParentCategories(price.serviceCategories)"
              :key="index"
            >
              <v-expansion-panel-header>
                <input-checkbox
                  v-bind:any="someServicesInParentCategorySelected(parentCategory.id)"
                  v-bind:title="parentCategory.name"
                  v-bind:value="allServicesInParentCategorySelected(parentCategory.id)"
                  v-on:input="addServicesInParentCategoryToList(parentCategory.id)"
                  v-on:click.native.capture.stop=""
                />
              </v-expansion-panel-header>
              <v-expansion-panel-content eager>
                <div
                  class="increase-service-prices-service-selector__service-row"
                  v-for="service in getServicesByCategoryId(selectedParentCategoryId)"
                  :key="service.value"
                >
                  <input-checkbox
                    v-bind:title="service.title"
                    v-bind:value="isServiceSelected(service.value)"
                    v-on:input="addServiceToList(service.value)"
                    v-on:click.native.capture.stop=""
                  />
                  <the-rub
                    class="increase-service-prices-service-selector__service-row__price"
                    currency="р"
                    show-kop="auto"
                    v-bind:kop="service.price"
                  />
                </div>
                <v-expansion-panels
                  accordion
                  v-model="serviceSubcategoryPanel"
                >
                  <v-expansion-panel
                    v-for="(parentCategory, index) in getSubcategories(parentCategory.id)"
                    :key="index"
                  >
                    <v-expansion-panel-header>
                      <input-checkbox
                        v-bind:any="someServicesInSubcategorySelected(parentCategory.id)"
                        v-bind:disabled="!getServicesByCategoryId(parentCategory.id).length"
                        v-bind:title="parentCategory.name"
                        v-bind:value="allServicesInSubcategorySelected(parentCategory.id)"
                        v-on:input="addServicesInSubcategoryToList(parentCategory.id)"
                        v-on:click.native.capture.stop=""
                      />
                    </v-expansion-panel-header>
                    <v-expansion-panel-content>
                      <div v-if="selectedSubcategoryId && index === serviceSubcategoryPanel">
                        <div
                          class="increase-service-prices-service-selector__service-row"
                          v-for="service in getServicesByCategoryId(selectedSubcategoryId)"
                          :key="service.value"
                        >
                          <input-checkbox
                            v-bind:title="service.title"
                            v-bind:value="isServiceSelected(service.value)"
                            v-on:input="addServiceToList(service.value)"
                            v-on:click.native.capture.stop=""
                          />
                          <the-rub
                            class="increase-service-prices-service-selector__service-row__price"
                            currency="р"
                            show-kop="auto"
                            v-bind:kop="service.price"
                          />
                        </div>
                      </div>
                    </v-expansion-panel-content>
                  </v-expansion-panel>
                </v-expansion-panels>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>
    <div class="increase-service-prices-service-selector__controls">
      <button
        class="increase-service-prices-service-selector__controls__button-send"
        type="button"
        v-bind:disabled="!serviceList.length"
        @click="onSubmit"
      >Далее</button>
    </div>
  </v-row>
</template>

<script>

import InputCheckbox from '@/components/InputCheckbox.vue';
import TheRub from '@/components/TheRub.vue';

/**
 * @description Название события "Отправить форму".
 * @type {string}
 */
const NAME_EVENT_SUBMIT = 'submit';

export default {
  name: 'IncreaseServicePricesServiceSelector',
  components: { TheRub, InputCheckbox },
  methods: {
    /**
     * @description Обработать событие отправки формы.
     * @returns {void}
     */
    onSubmit() {
      this.$emit(NAME_EVENT_SUBMIT, this.serviceList);
    },
    /**
     * @description Получить родительские категории прайс листа.
     * @returns {Array}
     */
    getParentCategories(categories) {
      return categories?.filter(
        (category) => category.parentCategoryId === null
          && this.getAllServicesInParentCategory(category.id).length,
      );
    },
    /**
     * @description Получить дочернии категории по id родительской категории.
     * @returns {Array}
     */
    getSubcategories(parentCategoryId) {
      const categories = this.prices.flatMap((price) => price.serviceCategories);
      return categories?.filter(
        (category) => category.parentCategoryId === parentCategoryId
          && this.getServicesByCategoryId(category.id).length,
      );
    },
    /**
     * @description Получить услуги категории.
     * @returns {Array}
     */
    getServicesByCategoryId(categoryId) {
      return this.services.filter((service) => service.categoryId === categoryId);
    },
    /**
     * @description Выбраны ли все услуги в подкатегории.
     * @returns {boolean}
     */
    allServicesInSubcategorySelected(categoryId) {
      const services = this.getServicesByCategoryId(categoryId);
      return services.length > 0 && services.every(
        (service) => this.serviceList.includes(service.value),
      );
    },
    /**
     * @description Выбраны ли некоторые (но не все) услуги в подкатегории.
     * @returns {boolean}
     */
    someServicesInSubcategorySelected(categoryId) {
      const services = this.getServicesByCategoryId(categoryId);
      const selectedCount = services.filter(
        (service) => this.serviceList.includes(service.value),
      ).length;
      return selectedCount > 0 && selectedCount < services.length;
    },
    /**
     * @description Выбрать все сервисы в подкатегории.
     * @returns {boolean}
     */
    addServicesInSubcategoryToList(categoryId) {
      const servicesIds = this.getServicesByCategoryId(categoryId).map((service) => service.value);
      if (this.allServicesInSubcategorySelected(categoryId)) {
        this.serviceList = this.serviceList.filter((serviceId) => !servicesIds.includes(serviceId));
      } else {
        this.serviceList.push(
          ...servicesIds,
        );
      }
    },
    /**
     * @description Выбрана ли услуга.
     * @returns {boolean}
     */
    isServiceSelected(serviceId) {
      return this.serviceList.includes(serviceId);
    },
    /**
     * @description Выбрать услугу.
     * @returns {void}
     */
    addServiceToList(serviceId) {
      if (this.isServiceSelected(serviceId)) {
        const index = this.serviceList.indexOf(serviceId);
        if (index !== -1) {
          this.serviceList.splice(index, 1);
        }
      } else {
        this.serviceList.push(serviceId);
      }
    },
    /**
     * @description Выбраны ли все услуги в родительской категории.
     * @returns {boolean}
     */
    allServicesInParentCategorySelected(categoryId) {
      const allServices = this.getAllServicesInParentCategory(categoryId);
      return allServices.length > 0 && allServices.every(
        (serviceId) => this.serviceList.includes(serviceId),
      );
    },
    /**
     * @description Выбраны ли некоторые услуги в родительской категории.
     * @returns {boolean}
     */
    someServicesInParentCategorySelected(categoryId) {
      const allServices = this.getAllServicesInParentCategory(categoryId);
      const selectedCount = allServices.filter(
        (serviceId) => this.serviceList.includes(serviceId),
      ).length;
      return selectedCount > 0 && selectedCount < allServices.length;
    },
    /**
     * @description Получить все услуги родительской категории.
     * @returns {Array}
     */
    getAllServicesInParentCategory(categoryId) {
      const services = this.getServicesByCategoryId(categoryId).flatMap(
        (service) => service.value,
      );
      const subcategories = this.getSubcategories(categoryId);
      const servicesInSubcategories = subcategories?.flatMap(
        (subcategory) => this.getServicesByCategoryId(subcategory.id).flatMap(
          (service) => service.value,
        ),
      );
      return [...services, ...servicesInSubcategories];
    },
    /**
     * @description Выбрать все сервисы в родительской категории.
     * @returns {boolean}
     */
    addServicesInParentCategoryToList(categoryId) {
      const categoryServicesIds = this.getServicesByCategoryId(categoryId).map(
        (service) => service.value,
      );
      const servicesInSubcategories = this.getSubcategories(categoryId);
      const servicesInSubcategoriesIds = servicesInSubcategories.flatMap(
        (subcategory) => this.getServicesByCategoryId(subcategory.id).flatMap(
          (service) => service.value,
        ),
      );
      const servicesIds = categoryServicesIds.concat(servicesInSubcategoriesIds);
      if (this.allServicesInParentCategorySelected(categoryId)) {
        this.serviceList = this.serviceList.filter((serviceId) => !servicesIds.includes(serviceId));
      } else {
        this.serviceList.push(
          ...servicesIds,
        );
      }
    },
    /**
     * @description Получить все услуги в прайс-листе.
     * @param {Object} priceList - Прайс-лист.
     * @returns {Array}
     */
    getAllServicesInPriceList(priceList) {
      const parentCategories = this.getParentCategories(priceList.serviceCategories);
      return parentCategories?.flatMap(
        (category) => this.getAllServicesInParentCategory(category.id),
      ) ?? [];
    },
    /**
     * @description Выбраны ли все услуги в прайс-листе.
     * @param {Object} priceList - Прайс-лист.
     * @returns {boolean}
     */
    allServicesInPriceListSelected(priceList) {
      const allServices = this.getAllServicesInPriceList(priceList);
      return allServices.length > 0 && allServices.every(
        (serviceId) => this.serviceList.includes(serviceId),
      );
    },
    /**
     * @description Выбраны ли некоторые услуги в прайс-листе.
     * @param {Object} priceList - Прайс-лист.
     * @returns {boolean}
     */
    someServicesInPriceListSelected(priceList) {
      const allServices = this.getAllServicesInPriceList(priceList);
      const selectedCount = allServices.filter(
        (serviceId) => this.serviceList.includes(serviceId),
      ).length;
      return selectedCount > 0 && selectedCount < allServices.length;
    },
    /**
     * @description Выбрать/снять выбор всех услуг в прайс-листе.
     * @param {Object} priceList - Прайс-лист.
     * @returns {void}
     */
    toggleServicesInPriceList(priceList) {
      const servicesIds = this.getAllServicesInPriceList(priceList);
      if (this.allServicesInPriceListSelected(priceList)) {
        this.serviceList = this.serviceList.filter(
          (serviceId) => !servicesIds.includes(serviceId),
        );
      } else {
        const newServices = servicesIds.filter(
          (serviceId) => !this.serviceList.includes(serviceId),
        );
        this.serviceList.push(...newServices);
      }
    },
    /**
     * @description Отменить выбор услуг.
     * @returns {void}
     */
    refreshServices() {
      this.serviceList = [];
    },
  },
  computed: {
    selectedParentCategoryId() {
      const categories = this.getParentCategories(
        this.prices[this.servicePriceListPanel]?.serviceCategories,
      );
      return categories ? categories[this.serviceCategoryPanel]?.id : null;
    },
    selectedSubcategoryId() {
      const subcategories = this.getSubcategories(this.selectedParentCategoryId);
      return subcategories ? subcategories[this.serviceSubcategoryPanel]?.id : null;
    },
  },
  data() {
    return {
      /**
       * @description Раскрытая панель прайс-листа.
       * @type {Number}
       */
      servicePriceListPanel: null,
      /**
       * @description Раскрытая панель категории.
       * @type {Number}
       */
      serviceCategoryPanel: null,
      /**
       * @description Раскрытая панель категории.
       * @type {Number}
       */
      serviceSubcategoryPanel: null,
      /**
       * @description Выбранные услуги.
       * @type {Array}
       */
      serviceList: [],
    };
  },
  props: {
    /**
     * @description Прайс категорий
     * @type Array<ServicePriceList>
     */
    prices: {
      type: Array,
      required: true,
    },
    /**
     * @description Список услуг для выбора.
     * @type {Array}
     */
    services: {
      type: Array,
      required: true,
    },
  },
};
</script>

<style scoped lang="scss">
@use "@/scss/buttons";
.increase-service-prices-service-selector {
  &__service-row {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 16px 24px;
    &__price {
      white-space: nowrap;
    }
  }
  &__controls {
    max-width: 340px;
    display: flex;
    align-items: center;
    gap: 10px;
    margin: 30px auto 0;
    &__button-send {
      @include buttons.btn-blue(170px, 45px, 16px);
      max-width: 100%;

      &:before {
        content: "";
        background-repeat: no-repeat;
        background-size: contain;
        text-align: center;
      }

      &:disabled {
        border-color: var(--unfocus-color);
      }
    }
  }
}
.v-expansion-panel {
  overflow-wrap: anywhere;
}

</style>
